import axios from 'axios';
const member = {
    
	actions: {
		processmember(context, userdata){
			return new Promise((resolve, reject) => {				
				axios({url: '/Member/ProcessMember', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(respdata => {	                   									
					resolve(respdata)
				})
				.catch(err => {									
					reject(err)
				})
			})
		},	
		getmember({rootState}){
			return new Promise((resolve, reject) => {				
				axios.get('/Member/GetMember?Username='+rootState.auth.token)
				.then(resp => resp.data)
				.then(respdata => {					
					resolve(respdata)
				})
				.catch(err => {					
					reject(err)
				})
			})
		},   
		getmemberbyid({rootState},Id){
			return new Promise((resolve, reject) => {				
				axios.get('/Member/GetMemberbyId?Id='+Id+'&Username='+rootState.auth.token)
				.then(resp => resp.data)
				.then(respdata => {					
					resolve(respdata)
				})
				.catch(err => {					
					reject(err)
				})
			})
		},   
		getmemberbysearch({rootState},searchVal){
			return new Promise((resolve, reject) => {				
				axios.get('/Member/GetMemberbySearch?SearchItem='+searchVal+'&Username='+rootState.auth.token)
				.then(resp => resp.data)
				.then(respdata => {					
					resolve(respdata)
				})
				.catch(err => {					
					reject(err)
				})
			})
		}    
	}
}

export default member